import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import AppLoader from 'components/AppLoader';
import { authActions, authSelectors } from 'redux/auth';
import usePrevious from 'hooks/usePrevious';

const AuthRoute = ({ auth: requiresAuth = true, ...args }) => {
  const dispatch = useDispatch();

  const isLoggedIn = useSelector(authSelectors.getUserIsLoggedIn);

  const wasLoggedIn = usePrevious(isLoggedIn);

  if (isLoggedIn === null) {
    dispatch(authActions.initAuth({ location: args.location }));

    return <AppLoader />;
  }

  if (isLoggedIn === requiresAuth) {
    return <Route {...args} />;
  }

  if (!isLoggedIn) {
    return wasLoggedIn
      ? <Redirect to={{ pathname: '/login' }} />
      : <Redirect to={{ pathname: '/login', state: { redirect: args.location } }} />;
  }

  return (
    <Redirect to={args.location?.state?.redirect || { pathname: '/' }} />
  );
};

AuthRoute.propTypes = {
  auth: PropTypes.bool,
};

export default AuthRoute;
